import { uniqBy } from 'lodash-es';

export class DataProviderHelper {
  public static filterDuplicates(list) {
    return uniqBy(list, 'ts_path');
  }
}
